/**
 * Monkey-patch attachShadow to inject flex overrides into shopify-accelerated-checkout-cart.
 * Forces buttons to display inline in 2 or 3 columns instead of stacking vertically.
 * Must run before Shopify's checkout component is defined.
 * Skipped on the /cart page where the full-page cart uses its own layout.
 */
(function () {
  // Skip the patch on the full cart page
  if (document.querySelector('.cart-page') || window.location.pathname === '/cart' || window.location.pathname === '/cart/') return;

  const originalAttachShadow = Element.prototype.attachShadow;
  Element.prototype.attachShadow = function (init) {
    const shadow = originalAttachShadow.call(this, init);
    if (this.tagName === 'SHOPIFY-ACCELERATED-CHECKOUT-CART') {
      const style = document.createElement('style');
      style.textContent = `
        .wallet-button-wrapper {
          padding: 0 !important;
          margin: 0 !important;
        }
        .wallet-cart-grid {
          flex-direction: row !important;
          flex-wrap: nowrap !important;
          margin: 0 !important;
          padding: 0 !important;
          gap: 6px !important;
        }
        .wallet-cart-grid .wallet-cart-button-container {
          flex: 1 1 0 !important;
          min-width: 0 !important;
          margin: 0 !important;
        }
        .wallet-cart-grid .wallet-cart-button {
          width: 100% !important;
        }
        .wallet-cart-grid:has(.wallet-cart-button-container:nth-of-type(1):last-of-type) .wallet-cart-button-container {
          flex: 1 1 100% !important;
        }
      `;
      shadow.appendChild(style);
    }
    return shadow;
  };
})();
